module.exports = __webpack_public_path__ + "static/img/BL.feadcac9.svg";